import React from "react"

const StarActive = ({ smaller }) => {
  return !smaller ? (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7147 0.878115C10.8045 0.601722 11.1955 0.601722 11.2853 0.878115L13.6268 8.0845C13.667 8.20811 13.7822 8.2918 13.9121 8.2918H21.4894C21.78 8.2918 21.9008 8.66368 21.6657 8.8345L15.5356 13.2883C15.4304 13.3647 15.3864 13.5001 15.4266 13.6237L17.7681 20.8301C17.8579 21.1065 17.5416 21.3363 17.3065 21.1655L11.1763 16.7117C11.0712 16.6353 10.9288 16.6353 10.8237 16.7117L4.69355 21.1655C4.45843 21.3363 4.14209 21.1065 4.23189 20.8301L6.57339 13.6237C6.61355 13.5001 6.56956 13.3647 6.46441 13.2883L0.334292 8.8345C0.0991777 8.66368 0.22001 8.2918 0.510627 8.2918H8.08787C8.21784 8.2918 8.33302 8.20811 8.37319 8.0845L10.7147 0.878115Z"
        fill="#1D395A"
      />
    </svg>
  ) : (
    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83145 0.878115C5.92126 0.601722 6.31228 0.601722 6.40209 0.878115L7.42272 4.01929C7.46288 4.1429 7.57807 4.22658 7.70803 4.22658H11.0109C11.3015 4.22658 11.4223 4.59847 11.1872 4.76929L8.51515 6.71064C8.41001 6.78703 8.36601 6.92244 8.40617 7.04605L9.4268 10.1872C9.51661 10.4636 9.20026 10.6935 8.96515 10.5226L6.29311 8.58128C6.18796 8.50489 6.04558 8.50489 5.94043 8.58128L3.26839 10.5226C3.03328 10.6935 2.71693 10.4636 2.80674 10.1872L3.82737 7.04605C3.86753 6.92244 3.82353 6.78703 3.71839 6.71064L1.04635 4.76929C0.811232 4.59847 0.932064 4.22658 1.22268 4.22658H4.52551C4.65547 4.22658 4.77066 4.1429 4.81082 4.01929L5.83145 0.878115Z"
        fill="#1D395A"
      />
    </svg>
  )
}

export default StarActive
